import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import Shell from "../../../common/components/Shell/Shell";
import DocumentsPresenter from "./DocumentsPresenter";
import DTODocuments from "./DTODocuments";
import { useTranslation } from "react-i18next";

interface empDetailProps {
  name: string;
  designation: string;
}
function DocumentsController() {
  const { t, i18n } = useTranslation();

  return (
    <Shell>
      <Grid
        container
        style={{
          maxWidth: "auto",
          marginLeft: i18n.language == "en" ? "7.25em" : "",
        }}
      >
        <DocumentsPresenter trans={t} i18n={i18n} />
      </Grid>
    </Shell>
  );
}
export default DocumentsController;
